import { App as F7App, View } from 'framework7-react';
import { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { isIPhone } from './config/device';
import { paths } from './config/paths';
import { store } from './config/store';
import { endpoint } from './consts/api';
import { ThemeId, themeId as THEME_IDS } from './consts/shop';
import { routes } from './routes';
import { initKarte, sendKarteView } from './utils/karte';
import 'react-circular-progressbar/dist/styles.css';
import '@/utils/checkECall';

const f7params = {
  routes,
  name: 'Maikuru',
  theme: 'ios',
  view: {
    browserHistory: true,
    browserHistorySeparator: '',
    unloadTabContent: true,
    iosSwipeBack: false,
    preloadPreviousPage: false,
  },
  navbar: {
    mdCenterTitle: true,
  },
  statusbar: {
    enabled: false,
    iosOverlaysWebView: false,
  },
  dialog: {
    title: 'My App',
    buttonOk: 'はい',
    buttonCancel: 'いいえ',
  },
  iosTranslucentBars: false,
  on: {
    pageAfterIn: () => {
      sendKarteView();
    },
  },
};

const VALID_THEME_IDS: ReadonlySet<number> = new Set(Object.values(THEME_IDS));
const themeParam = Number(new URLSearchParams(location.search).get('theme'));
const theme = (VALID_THEME_IDS.has(themeParam) ? themeParam : 0) as ThemeId | 0;

// URL ?theme= による KARTE key の決定は store の globalTheme 正規化とは
// 独立した関心事。DEFAULT(1) を含む全ての有効な ?theme= 値で
// KARTE key をロックし、affiliate 解決での上書きを防止する。
if (theme) {
  initKarte(theme, true);
}

export const App = () => {
  useEffect(() => {
    if (window && isIPhone) {
      window.document
        .querySelector('body')
        ?.setAttribute('style', 'min-height: 100vh');
    }
    if (window && endpoint.GA_TRACKING_ID) {
      ReactGA.initialize(endpoint.GA_TRACKING_ID);
    }
  }, []);
  useEffect(() => {
    const handleExternalLinkClick = (event: MouseEvent) => {
      const target = event.target as Element | null;
      if (!target) return;

      const anchor = target.closest('a');
      if (!(anchor instanceof HTMLAnchorElement)) return;
      const href = anchor.getAttribute('href');
      if (!href) return;

      const isTelLink = href.startsWith('tel:') || href.startsWith('tel://');
      const isExternalClass = anchor.classList.contains('external');
      if (!isTelLink && !isExternalClass) return;

      const url = isTelLink
        ? href
        : new URL(href, window.location.href).toString();
      if (window.ReactNativeWebView?.postMessage) {
        event.preventDefault();
        event.stopPropagation();
        window.ReactNativeWebView.postMessage(
          JSON.stringify({ type: 'external-link', url }),
        );
        return;
      }

      event.preventDefault();
      window.open(url, '_blank', 'noopener,noreferrer');
    };

    document.addEventListener('click', handleExternalLinkClick, true);
    return () => {
      document.removeEventListener('click', handleExternalLinkClick, true);
    };
  }, []);
  return (
    <F7App {...f7params} store={store}>
      <View
        main
        url={paths.root}
        onViewInit={async () => {
          if (theme) {
            await store.dispatch('setGlobalThemeId', { themeId: theme });
          }
        }}
      />
    </F7App>
  );
};
